import ApiProvider, { BookingUrlParams } from './ApiProvider'
import Booking, { BookingStatus } from '../models/Booking'
import { User } from '../models/Booking'
import { Source } from '../models/Source'
import Offer from '../models/Offer'
import Venue from '../models/Venue'
import BookingType from '../models/BookingType'
import { BookingTime } from './TimesProvider'
import { Tag } from '../services/BookingDetailsProvider'
import AnalyticsService from '../services/AnalyticsService'
import Vue from 'vue';

class ConfirmedBooking extends Booking {
    status: BookingStatus
    // deposits: any[] = []
    offer: Offer | null
    // packages: any
    reference: string
    booking: any

    constructor (data: any) {
        super()
        this.reference = data.booking.reference
        this.status = data.bookingStatus
        this.booking = data.booking
        this.venue = data.venue
        this.pax = data.booking.num_people
        this.date = new Date(data.booking.date)

        this.user = new User()
        this.offer = new Offer({})
    }
}

export default class SubmitBookingProvider extends ApiProvider {
    booking: Booking
    analyticsService: AnalyticsService
    analyticsId?: string
    urlOptions: BookingUrlParams

    constructor (booking: Booking, urlOptions: BookingUrlParams) {
        super()
        this.booking = booking
        this.urlOptions = urlOptions
        this.analyticsService = new AnalyticsService(urlOptions.source)
    }

    setAnalyticsId (analyticsId?: string): this {
        this.analyticsId = analyticsId

        return this
    }

    submitBooking (booking: Booking, accessToken: string): Promise<ConfirmedBooking> {
        const requestUrl = this.baseUrl + '/bookings'            
        const options = {
            headers: {
                'DMN-Access-Token': accessToken
            }
        }

        let params = booking.toQuery()

        if (this.urlOptions.source) {
            params.source = this.urlOptions.source
        }

        if (this.urlOptions.affiliateId) {
            params.affiliateId = this.urlOptions.affiliateId
        }

        if (this.urlOptions.customSource) {
            params.partner_source = this.urlOptions.customSource
        }

        return this.post(requestUrl, params, options)
            .then((response) => {
                const payload = response.data.payload
                const bookingDetails = new ConfirmedBooking(payload)

                this.analyticsService.trackEvent('Booking Widget v2', 'Booking Placed', bookingDetails.status, 1)

                return bookingDetails
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/SubmitBookingProvider.ts